/**
 * SetSettingsResult.ts
 */
export class SetSettingsResult {
    constructor(responseCode, data) {
        this.responseCode = responseCode;
        this.data = data;
    }
    getResponseCode() {
        return this.responseCode;
    }
    getData() {
        return this.data;
    }
}
//# sourceMappingURL=SetSettingsResult.js.map